import { useSplitClient } from 'contrastBase/state'
import React from 'react'
import {
  StepContent,
  WizardStepContext,
  WizardStepContextValueType
} from '../agent-wizard-steps'
import { CodeBlockFullHeight } from './common'
import { AgentDropdown, useOrgUuid } from '../agent-config'
import { useOrganizationAgents } from '../../../../keys-settings/api/use-agent-keys'
import { KubernetesNoAgentsWarning } from './kubernetes-no-agents-warning'
import { Form } from '@contrast-security-inc/design-system-forms'
import { useFormContext } from 'react-hook-form'
import { debounce } from 'lodash'
import { TYPING_DEBOUNCE_MS } from '../common/constants'

export const hasNoAgentUsers = (multipleAgentUsersEnabled, isLoading, agents) =>
  multipleAgentUsersEnabled && !isLoading && agents.length === 0

export const StepKubernetesDownloadSetup = () => {
  const { isSplitTreatmentOn } = useSplitClient()
  const isMultipleUsersEnabled = isSplitTreatmentOn(
    'PROD-3155_multiple_agent_users'
  )

  const orgUuid = useOrgUuid().orgUuid
  const { isLoading, data } = useOrganizationAgents({
    orgUuid,
    filterText: ''
  })

  return hasNoAgentUsers(isMultipleUsersEnabled, isLoading, data?.agents) ? (
    <KubernetesNoAgentsWarning stepContentMsg="detail_downloadAndSetupTheValuesFileNoAgents" />
  ) : (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <Form onSubmitSuccess={() => {}}>
      <StepKubernetesDownloadSetupWithAgents
        isMultipleUsersEnabled={isMultipleUsersEnabled}
      />
    </Form>
  )
}

const StepKubernetesDownloadSetupWithAgents = ({
  isMultipleUsersEnabled
}: {
  isMultipleUsersEnabled: boolean
}) => {
  const ctx: WizardStepContextValueType = React.useContext(WizardStepContext)

  const { watch } = useFormContext()

  React.useEffect(() => {
    const formSubscribe = watch(
      debounce((formData) => {
        ctx.updateAgentUid(formData?.agent?.uid)
      }, TYPING_DEBOUNCE_MS)
    )

    return () => formSubscribe.unsubscribe()
  }, [watch, ctx])

  return (
    <>
      <StepContent
        step={{
          Content: {
            message: 'detail_downloadAndSetupTheValuesFile'
          }
        }}
      />

      {isMultipleUsersEnabled && (
        <>
          {' '}
          <AgentDropdown /> <br />{' '}
        </>
      )}

      <CodeBlockFullHeight
        codeTemplate={`clusterDefaults:
  # If enabled, configure cluster-wide defaults.
  enabled: true
  # Required. The Contrast UI instance to use. Defaults at the general SAAS instance.
  url: {agentUrl}
  # Required. The API Key from the Contrast UI.
  apiKeyValue: {api_key}
  # Required. The Service Key from the Contrast UI.
  serviceKeyValue: {service_key}
  # Required. The User Name from the Contrast UI.
  userNameValue: {user_uid}
  # Optional. Any custom configuration to use. Must be in the format of the standard YAML file.
  yaml: |-
    enable: true

imageCredentials:
  # Name of the registry credential secret that should be used to pull the above image.
  pullSecretName: image-credentials
  # If enabled, a registry credential secret will be created using the above name and below credentials.`}
      />
    </>
  )
}
